module.exports = hzero_dll_common;